import { render } from "./ImportProductosImperdonables.vue?vue&type=template&id=d4af0b24"
import script from "./ImportProductosImperdonables.vue?vue&type=script&lang=js"
export * from "./ImportProductosImperdonables.vue?vue&type=script&lang=js"

import "./ImportProductosImperdonables.vue?vue&type=style&index=0&id=d4af0b24&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__